import { Card } from "@astryxdesign/core/Card";
import { Grid } from "@astryxdesign/core/Grid";
import { HStack, VStack } from "@astryxdesign/core/Stack";
import { Text } from "@astryxdesign/core/Text";
import type { FxRates, MoneySummary as Summary } from "../../../shared/money";
import { formatUah, fxLine } from "../../lib/money";

interface Props {
  summary: Summary;
  fx: FxRates;
}

/** Dashboard tiles — the one place Card is right (widgets, not list rows). */
export function MoneySummary({ summary, fx }: Props) {
  const tiles: Array<{ label: string; value: string; accent?: boolean }> = [
    { label: "Per month", value: formatUah(summary.monthlyUah), accent: true },
    { label: "Left this month", value: formatUah(summary.restOfMonthUah) },
    { label: "Installments left", value: formatUah(summary.installmentsLeftUah) },
  ];

  return (
    <VStack gap={1.5}>
      <Grid columns={3} gap={2}>
        {tiles.map((t) => (
          <Card key={t.label} padding={3}>
            <VStack gap={0.5}>
              <Text type="supporting" size="xsm" color="secondary">
                {t.label}
              </Text>
              <Text type="body" weight="bold" size="lg" color={t.accent ? "accent" : "primary"}>
                {t.value}
              </Text>
            </VStack>
          </Card>
        ))}
      </Grid>
      <HStack gap={1} justify="end">
        <Text type="supporting" size="xsm" color="secondary">
          {fxLine(fx)}
        </Text>
      </HStack>
    </VStack>
  );
}
